<template>
    <div id="vue-newsletter-signup">
        
        <div class="row expanded newsletter bg-dgrey img-txt-pnls" data-equalizer>
            <div class="small-12 large-6 large-push-6 columns credit-c img" data-equalizer-watch>
                <span class="span-image"></span>
                <p class="credit">© Troy Mayne</p>
            </div>
    
            <div class="small-12 large-6 large-pull-6 columns pddxy-50 txt" data-equalizer-watch>
                <div class="row small-collapse medium-uncollapse white-text">
                    <div class="small-12 columns">
                        <h2>Get updates</h2>
                        <p class="get-updates">Sign up and we’ll keep you up-to-date with the latest news on WWF’s work to protect endangered wildlife and habitats and how you can help make a real difference to their future.</p>
                    </div>
                </div>
                <div class="row small-collapse medium-uncollapse wwf-form dark">
    
                    <div class="small-12 medium-6 columns ng-invalid">
                        <span class="input-border">
                            <input name="firstName" placeholder="First name" type="text" :class="{'border-red': errors.has('firstName')}" data-vv-as="First name" v-model="firstName" v-validate="'required'" id="target-newsletter">
                        </span>
                        <div class="alert-box-c">
                            <span class="alert-box" v-show="errors.has('firstName')">{{errors.first('firstName')}}</span>
                        </div>
                    </div>
    
                    <div class="small-12 medium-6 columns ng-invalid">
                        <input name="lastName" placeholder="Last name" type="text" :class="{'border-red': errors.has('lastName')}" data-vv-as="Last name" v-model="lastName" v-validate="'required'">
                        <div class="alert-box-c">
                            <span class="alert-box" v-show="errors.has('lastName')">{{errors.first('lastName')}}</span>
                        </div>
                    </div>
    
                    <div class="small-12 medium-6 columns ng-invalid">
                        <input name="email" placeholder="Email" type="text" :class="{'border-red': errors.has('email') || errors.has('newsletterCheckEmail')}" v-model="email" v-validate="{required: true, email: true, newsletterCheckEmail: true}">
                        <div class="input-loading" v-if="checkEmailLoading">
                            <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/2903/dist/assets/img/loading-tail-spin.svg" />
                        </div>
                        <div class="alert-box-c">
                            <span class="alert-box" v-show="errors.has('email')">{{errors.first('email')}}</span>
                        </div>
                    </div>
    
                    <div class="small-12 medium-6 columns ng-invalid">
                        <input name="postCode" placeholder="Postcode" type="text" :class="{'border-red': errors.has('postCode')}" v-model="postCode" data-vv-as="Postcode" v-validate="'required|numeric'">
                        <div class="alert-box-c">
                            <span class="alert-box" v-show="errors.has('postCode')">{{errors.first('postCode')}}</span>
                        </div>
                    </div>
    
                    <div class="small-12 columns">
                        <a v-on:click="postForm" class="bttn-lrg-arrw">SIGNUP</a>
                    </div>
    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Validator } from "vee-validate";
import { mapState } from "vuex";

export default {
    name: 'newsletterSignup',
    data() {
        return {
            firstName: '',
            lastName: '',
            email: '',
            postCode: '',
            isOpen: '',
            timeout: null,
            lastTimestamp: Date.now(),
            checkEmailLoading: false,
            emailRegex: /.+\@.+\..+/,
        }
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        })
    },

    created() {
        const newsletterCheckEmail = email => {
            if (email.length > 0 && this.emailRegex.test(email)) {
                return new Promise((resolve, reject) => {
                    let timestamp = Date.now(); // timestamp for this api call
                    this.lastTimestamp = timestamp; // 1 , 2 , 3
                    this.checkEmailLoading = true;
                    // Fetch Suggestions
                    this.$store
                        .dispatch("validateEmail", email)
                        .then((response) => {
                            if (response && timestamp >= this.lastTimestamp) {
                                this.checkEmailLoading = false;
                                resolve(response);
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                            this.checkEmailLoading = false;
                            // If the call failed, do not keep the user from donating
                            resolve({
                                valid: true
                            });
                        });
                })
            } else {
                return {
                    valid: false,
                    data: { message: "Email invalid" }
                };
            }
        }

        Validator.extend("newsletterCheckEmail", {
            validate: newsletterCheckEmail,
            getMessage: (field, params, data) => data.message
        });
    },

    methods: {
        postForm: function () {
            this.$validator.validateAll().then(result => {
                if (result) {
                    var postBody = {
                        email: this.email,
                        firstName: this.firstName,
                        lastName: this.lastName,
                        postcode: this.postCode,
                        programName: this.$config.NEWSLETTERSUBSCRIBELIST,
                        cookieID: this.$cookie.get("_mkto_trk"),
                        ssoId: this.$store.getters.ssoId,
                    }
                    
                    this.$store
                    .dispatch("saveLead", {
                      campaignId: 'newsletter-signup',
                      lead: postBody
                    })
                    .then(
                      response => {
                        console.log("subscribeNewsletter success");

                        if (window.dataLayer != undefined) {
                          window.dataLayer.push({
                            formName: 'newsletter-signup',
                            event: "formSubmitSuccessEvent"
                          });
                        }

                        //Reset form
                        this.firstName = "";
                        this.lastName = "";
                        this.email = "";
                        this.phone = "";
                        this.postCode = "";
                      },
                      error => {
                        console.error("subscribeNewsletter failed");
                      }
                    );


                    this.$store.commit("setPopupContent", {
                        title: 'Hi ' + this.firstName + ', welcome to WWF-Australia!',
                        message: 'We\'ll send an email to ' + this.email + ' to you soon.',
                        shareButton: false,
                        recommendedReading: true,
                        component: null,
                        componentparams: null
                    });
                    this.$store.commit("openPetitionPopup", true);
                }
                else {
                    console.log('form invalid');
                    // GTM Tracking
                    if (window.dataLayer != undefined) { window.dataLayer.push({ 'formName': 'newsletter-signup', 'event': 'formSubmitEvent' }); }
                }
            })
        }
    }
}

</script>

<style scoped>

.wwf-form {
    padding: 0;
    min-height: 0;
    margin-bottom: 0;
}

.span-image {
    background-image: url(https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/2903/dist/assets/img/turtle-parallax.jpg)
}

.get-updates {
    margin-bottom: 15px;
}

/* STYLE FOR FOCUS BORDER */

span.input-border {
    display: block;
    overflow: hidden;
    border-radius: 3px;
    margin: 0;
    position: relative;
}

span.input-border input {
    margin: 0!important;
}

span.input-border:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 35%;
    background-color: rgba(255,255,255,.3);
    -webkit-transform: skew(35deg) translate(-100%,0%);
        -ms-transform: skew(35deg) translate(-100%,0%);
            transform: skew(35deg) translate(-100%,0%);
    -webkit-transform-origin: bottom;
        -ms-transform-origin: bottom;
            transform-origin: bottom;
}

span.input-border.open {
    -webkit-transform: scale(1.02);
        -ms-transform: scale(1.02);
            transform: scale(1.02);
    -webkit-box-shadow: 0 0 0 4px #06b94e, 0 10px 20px rgba(0,0,0,.5);
            box-shadow: 0 0 0 4px #06b94e, 0 10px 20px rgba(0,0,0,.5);
}

span.input-border.open:before {
    -webkit-animation: flashShine .4s cubic-bezier(0.860, 0.000, 0.070, 1.000) running;
            animation: flashShine .4s cubic-bezier(0.860, 0.000, 0.070, 1.000) running;
}

@-webkit-keyframes flashShine {
    0% { -webkit-transform: skew(35deg) translate(-100%,0%); transform: skew(35deg) translate(-100%,0%); }
    100% { -webkit-transform: skew(35deg) translate(500%,0%); transform: skew(35deg) translate(500%,0%); }
}

@keyframes flashShine {
    0% { -webkit-transform: skew(35deg) translate(-100%,0%); transform: skew(35deg) translate(-100%,0%); }
    100% { -webkit-transform: skew(35deg) translate(500%,0%); transform: skew(35deg) translate(500%,0%); }
}

span.input-border.open input {
    -webkit-box-shadow: none!important;
            box-shadow: none!important;
}

.input-loading {
    top: 6px;
    right: 20px;
}

</style>



// WEBPACK FOOTER //
// NewsletterSignup.vue?89a7e14e